// Sprint 4 Push 2: MahnungOutboundTile (DRY-RUN bis Petra-Outbound-API live).

import { useQuery } from "@tanstack/react-query";

import {
  MahnungOutboundResponse,
  fetchMahnungOutbound,
} from "../lib/api";
import { firmaDot } from "../lib/firma-colors";

export default function MahnungOutboundTile() {
  const query = useQuery<MahnungOutboundResponse, Error>({
    queryKey: ["mahnung-outbound"],
    queryFn: fetchMahnungOutbound,
    staleTime: 5 * 60_000,
  });

  if (query.isLoading) {
    return (
      <section className="rounded-2xl border border-slate-700/60 bg-slate-950 p-4 sm:p-5">
        <h2 className="text-[11px] font-semibold uppercase tracking-widest text-slate-100">
          Mahn-Outbound
        </h2>
        <p className="text-xs text-slate-400 mt-2">Lade …</p>
      </section>
    );
  }

  const items = query.data?.items ?? [];
  const nDry = query.data?.n_dry_run ?? 0;

  return (
    <section className="rounded-2xl border border-pink-500/40 bg-slate-950 p-4 sm:p-5 space-y-2">
      <header className="flex items-baseline justify-between gap-2">
        <h2
          className="text-sm font-semibold text-white"
          title="Cron 09:00 zieht offene Forderungen (Stufe 2/3, ≥14T offen, ≥100€). Live-Schaltung erst nach AVV-HalloPetra + TOOLTIME_OUTBOUND_LIVE=1. Bis dahin: persisted dry_run_logged."
        >
          Mahn-Outbound
          <span className="ml-2 text-[10px] uppercase tracking-wider text-neutral-500 font-normal">
            09:00 cron
          </span>
        </h2>
        <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded border border-amber-500/20 bg-amber-500/10 text-amber-300">
          DRY-RUN · {nDry}
        </span>
      </header>

      {items.length > 0 && (
        <ul className="space-y-1">
          {items.slice(0, 3).map((it) => (
            <li
              key={it.id}
              className="px-2 py-1.5 flex items-baseline justify-between gap-2"
            >
              <span className="flex items-center gap-2 text-xs text-white min-w-0">
                <span
                  aria-hidden="true"
                  className={`inline-block w-1.5 h-1.5 rounded-full shrink-0 ${
                    firmaDot(it.firma_id)
                  }`}
                />
                <span className="truncate">
                  Stufe {it.mahnstufe} · #{it.rg_nummer ?? it.forderung_id}
                </span>
              </span>
              <span className="text-[10px] tabular-nums text-pink-300 shrink-0">
                {it.betrag_eur
                  ? parseFloat(it.betrag_eur).toLocaleString("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    })
                  : "—"}
              </span>
            </li>
          ))}
          {items.length > 3 && (
            <li className="text-[10px] text-sky-300/80 pl-2">
              +{items.length - 3} weitere
            </li>
          )}
        </ul>
      )}
    </section>
  );
}
